import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Campaign, CampaignCreationStep, PricingConfig } from '../../types';

const initialState = {
  creationStep: 'none',
  isCampaignCreated: false,
  showLaunchConfirmed: false,
  campaign: {} as Campaign,
  campaigns: [] as Campaign[],
  pricingConfig: null as PricingConfig | null,
  campaignObjective: [] as {
    claim_type: string;
    claim_id: string;
    claim_subtypes: string[];
    campaign_objective: string;
    result_type: string;
    floor_price: string;
  }[],
};

const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    setCreationStep: (state, action: PayloadAction<CampaignCreationStep>) => {
      state.creationStep = action.payload;
    },
    setCampaign: (state, action: PayloadAction<Campaign>) => {
      state.campaign = action.payload;
      const updatedCampaign = action.payload;
      const index = state.campaigns.findIndex((campaign) => campaign.id === updatedCampaign.id);

      if (index !== -1) {
        state.campaigns[index] = updatedCampaign;
      } else {
        state.campaigns.push(updatedCampaign);
      }
    },
    setCampaigns: (state, action: PayloadAction<Campaign[]>) => {
      state.campaigns = action.payload;
    },
    setCampaignObjective: (
      state,
      action: PayloadAction<
        {
          claim_type: string;
          claim_id: string;
          claim_subtypes: string[];
          campaign_objective: string;
          result_type: string;
          floor_price: string;
        }[]
      >,
    ) => {
      state.campaignObjective = action.payload;
    },
    setIsCampaignCreated: (state, action: PayloadAction<boolean>) => {
      state.isCampaignCreated = action.payload;
    },
    setShowLaunchConfirmed: (state, action: PayloadAction<boolean>) => {
      state.showLaunchConfirmed = action.payload;
    },
    setPricingConfig: (state, action: PayloadAction<PricingConfig>) => {
      state.pricingConfig = action.payload;
    },
  },
});

export const {
  setCampaign,
  setCampaigns,
  setCreationStep,
  setIsCampaignCreated,
  setCampaignObjective,
  setShowLaunchConfirmed,
  setPricingConfig,
} = campaignsSlice.actions;

export default campaignsSlice.reducer;
